import AppListing from '../app-components/Listing/AppListing';

Vue.component('app-finance-credit-listing', {
    mixins: [AppListing],
    props:{
        listStatus:  {
            type: Array,
            default: () => []
        }
    },
    data: function() {
        return {
            showFilter: false,
            moduleFilters:{
                status: 0,
            },

            detailTransasctions: [],
            isLoadingDetail: false,
            UrlDownloadFinanceReport: null,
        }
    },
    methods: {
        openDetail(data) {
            this.$modal.show('credit-detail', {
                title: 'Warning!',
                text: 'Do you really want to delete this item?',
            })
            var _this6 = this;
            _this6.isLoadingDetail = true
            _this6.detailTransasctions = []

            var options = { params: { } };

            Object.assign(options.params, this.filters);
            axios.get(`${_this6.url}/${data.id}/detail`, options).then(function (response) {
                console.log('response', response)
                _this6.detailTransasctions = response.data.data
                setTimeout(() => {
                    _this6.isLoadingDetail = false
                }, 2000);
            }, function (error) {
                console.log('error', error)
                this.$modal.hide('credit-detail')
                setTimeout(() => {
                    _this6.isLoadingDetail = false
                }, 2000);
            });
            
        },
        beforeOpenDetailLog (event) {
            
        },
        detailLogClose(){
            this.$modal.hide('credit-detail')
        },
        buildUrlDownloadFinanceReport(){
            const baseUrl = this.url
            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction,
                    action: 'to-excel',
                }
            };
            
            Object.assign(options.params, this.filterObject(this.filters, function (val, key) { return val !== null }));
            const queryString = '?' + new URLSearchParams(options.params).toString();
            this.UrlDownloadFinanceReport = baseUrl+queryString;
        },
        loadData: function loadData(resetCurrentPage) {
            var _this6 = this;

            var options = {
                params: {
                    per_page: this.pagination.state.per_page,
                    page: this.pagination.state.current_page,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction
                }
            };

            if (resetCurrentPage === true) {
                options.params.page = 1;
            }

            Object.assign(options.params, this.filters);
            _this6.buildUrlDownloadFinanceReport()
            axios.get(this.url, options).then(function (response) {
                return _this6.populateCurrentStateAndData(response.data.data);
            }, function (error) {
                // TODO handle error
            });
        },
        onChangeStatus: function (status) { 
            this.status = status
            this.moduleFilters.status = status
            this.applyFilters()
        },
    },
    mounted: function () {  
        this.buildUrlDownloadFinanceReport()
    },
});